module.exports = __webpack_public_path__ + "media/images/flags/1x1/mli-6d0050e701c12267409e1d22c4af254a.svg";